import { Tooltip } from "@samacare/design";
import Chip from "@samacare/design/core/Chip";

export const EditAndResubmitIndicator: React.FC = () => (
  <Tooltip title="EditAndResubmitIndicator">
    <Chip
      size="small"
      variant="filled"
      color="warning"
      label="Updating PA"
      sx={{
        width: "fit-content",
        mb: 1,
      }}
    />
  </Tooltip>
);
